export default __webpack_public_path__ + "static/media/view.c19b9e35.png";